// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import * as fundraiseActions from '../store/actions';
import {
  getFundraiseForm, getError, getIsButtonPressed, getData, getStatus
} from '../store/selectors';

import { Input, Button } from '../../../components';
import Navigation from '../../../common/Navigation/Navigation';
import CrossIcon from '../../../images/cancel.svg';
import AcceptIcon from '../../../images/success.svg';
import { CRAFTY_CLICKS_API_KEY } from '../../../config/apiKeys';
import styles from './styles';

class Fundraise extends Component {
  state = { errorMessage: null };

  componentWillMount() {
    const { setIsButtonPressed, getFundraisePageData, resetStatus } = this.props;
    setIsButtonPressed(false);
    getFundraisePageData();
    resetStatus();
  }

  findEmptyFields = (form) => {
    const errors = {
      CharityName: 'Enter legal name of organiation',
      CharityNumber: 'Enter charity number/registration number',
      TradingName: 'Enter trading name(s)',
      CharityURL: 'Enter url of organisation',
      ContactNumber: 'Enter Contact number',
      contactemail: 'Enter Contact email',
      ContactName: 'Enter Contact name',
      BankAccountNumber: 'Enter Account Number',
      BankSortCode: 'Enter Sort Code',
      AccountholderName: 'Enter Account Name',
    };
    this.setState({ errorMessage: null });
    return (
      Object.keys(form).every(
        (key) => {
          if (!form[key]) {
            this.setState({ errorMessage: errors[key] });
            return false;
          }
          return true;
        }
      )
    );
  }

  onChangeFormInput = (value, name) => {
    const { setFundraiseFormField, error, setError } = this.props;
    setFundraiseFormField(name, value);
    if (this.state.errorMessage) this.setState({ errorMessage: null });
    if (error) setError(null);
  }

  onSubmit = () => {
    const { fundraiseForm, validatPhoneNumber } = this.props;
    // eslint-disable-next-line no-useless-escape
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (this.findEmptyFields(fundraiseForm)) {
      if (regex.test(fundraiseForm.contactemail)) {
        validatPhoneNumber(
          {
            key: CRAFTY_CLICKS_API_KEY,
            country: 'gbr',
            phone_number: fundraiseForm.ContactNumber,
            get_network: true,
          },
          {
            key: CRAFTY_CLICKS_API_KEY,
            sortCode: fundraiseForm.BankSortCode,
            accountNumber: fundraiseForm.BankAccountNumber,
          },
          fundraiseForm
        );
      } else {
        this.setState({ errorMessage: 'Invalid contact email.' });
      }
    }
  }

  renderForm = () => {
    const {
      classes, fundraiseForm, error, data
    } = this.props;
    const { errorMessage } = this.state;
    const getPaid = 'Get paid: ';
    const getPaidText = `Enter your company bank details below,
      all details are verified instantly to ensure payments are made swiftly.`;

    return (
      <div className={classes.subContainer}>
        <h3 className={classes.headerText}>{data.title}</h3>
        <p className={classes.text}>{data.text && parse(data.text)}</p>
        <div className={classes.rowContainer}>
          <Input
            label={'Legal name of organiation:'}
            fixedWidth
            required
            name={'CharityName'}
            value={fundraiseForm.CharityName}
            onChange={this.onChangeFormInput}
          />
          <Input
            label={'Charity number/registration number:'}
            fixedWidth
            required
            name={'CharityNumber'}
            value={fundraiseForm.CharityNumber}
            onChange={this.onChangeFormInput}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Trading name(s):'}
            fixedWidth
            required
            name={'TradingName'}
            value={fundraiseForm.TradingName}
            onChange={this.onChangeFormInput}
          />
          <Input
            label={'Url of organisation:'}
            fixedWidth
            required
            name={'CharityURL'}
            value={fundraiseForm.CharityURL}
            onChange={this.onChangeFormInput}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Contact email:'}
            fixedWidth
            required
            name={'contactemail'}
            value={fundraiseForm.contactemail}
            onChange={this.onChangeFormInput}
          />
          <Input
            label={'Contact number:'}
            fixedWidth
            required
            name={'ContactNumber'}
            value={fundraiseForm.ContactNumber}
            onChange={this.onChangeFormInput}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Contact name:'}
            fixedWidth
            required
            name={'ContactName'}
            value={fundraiseForm.ContactName}
            onChange={this.onChangeFormInput}
          />
        </div>
        <div className={classes.line} />
        <span className={classes.getPaidText}>
          <span className={classes.getPaidTextBold}>{getPaid}</span>
          {getPaidText}
        </span>
        <div className={classes.rowContainer}>
          <Input
            label={'Account holder name:'}
            fixedWidth
            required
            name={'AccountholderName'}
            value={fundraiseForm.AccountholderName}
            onChange={this.onChangeFormInput}
          />
        </div>
        <div className={classes.rowContainer}>
          <Input
            label={'Bank sort-code:'}
            fixedWidth
            required
            name={'BankSortCode'}
            maxLength={6}
            value={fundraiseForm.BankSortCode}
            onChange={this.onChangeFormInput}
          />
          <Input
            label={'Bank account number:'}
            fixedWidth
            required
            name={'BankAccountNumber'}
            maxLength={8}
            value={fundraiseForm.BankAccountNumber}
            onChange={this.onChangeFormInput}
          />
        </div>
        {errorMessage ? <p className={classes.error}>{this.state.errorMessage}</p>
          : (error && <p className={classes.error}>{error}</p>)}
        <Button
          style={classNames(classes.button, (errorMessage || error) && classes.withError)}
          text={'submit'}
          onPress={this.onSubmit}
        />
      </div>
    );
  }

  renderConfifm = () => {
    const { classes, data, status } = this.props;
    const icon = status ? AcceptIcon : CrossIcon;
    const text = status ? (data.confirm_text && parse(data.confirm_text)) : 'Error';

    return (
      <div className={classes.subContainer}>
        <img
          className={classes.statusIcon}
          src={icon}
          alt={'StatusIcon'}
        />
        <p className={classNames(classes.text, classes.statusText)}>{text}</p>
      </div>
    );
  }

  render() {
    const { classes, isButtonPressed } = this.props;

    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          {isButtonPressed ? this.renderConfifm() : this.renderForm()}
        </div>
      </Navigation>
    );
  }
}

Fundraise.propTypes = {
  classes: PropTypes.object,
  fundraiseForm: PropTypes.object,
  setFundraiseFormField: PropTypes.func,
  error: PropTypes.string,
  validatPhoneNumber: PropTypes.func,
  isButtonPressed: PropTypes.bool,
  setIsButtonPressed: PropTypes.func,
  getFundraisePageData: PropTypes.func,
  data: PropTypes.object,
  resetStatus: PropTypes.func,
  status: PropTypes.bool,
  setError: PropTypes.func,
};

Fundraise.defaultProps = {
  classes: {},
  fundraiseForm: {},
  setFundraiseFormField: () => { },
  error: null,
  validatPhoneNumber: () => { },
  isButtonPressed: false,
  setIsButtonPressed: () => { },
  getFundraisePageData: () => { },
  data: {},
  resetStatus: () => { },
  status: null,
  setError: () => { },
};

const mapStateToProps = (state) => {
  return {
    fundraiseForm: getFundraiseForm(state),
    error: getError(state),
    isButtonPressed: getIsButtonPressed(state),
    data: getData(state),
    status: getStatus(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFundraisePageData: () => dispatch(fundraiseActions.getFundraisePageData()),
    setFundraiseFormField: (field, value) => dispatch(
      fundraiseActions.setFundraiseFormField(field, value)
    ),
    validatPhoneNumber: (data, dataForValidBank, dataForNextRequest) => dispatch(
      fundraiseActions.validatPhoneNumber(data, dataForValidBank, dataForNextRequest)
    ),
    setIsButtonPressed: isButtonPressed => dispatch(
      fundraiseActions.setIsButtonPressed(isButtonPressed)
    ),
    resetStatus: () => dispatch(fundraiseActions.resetStatus()),
    setError: error => dispatch(fundraiseActions.setError(error)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Fundraise));
